import api from '@/config/api'
import type { ApiResponse } from '@/shared/types/api'
import type { Structure, CreateStructureRequest, UpdateStructureRequest } from '@/shared/types/admin'

export const structuresApi = {
  getAll: () =>
    api.get<ApiResponse<Structure[]>>('/api/structures').then((r) => r.data.data),

  getById: (id: number) =>
    api.get<ApiResponse<Structure>>(`/api/structures/${id}`).then((r) => r.data.data),

  getActives: () =>
    api.get<ApiResponse<Structure[]>>('/api/structures/actives').then((r) => r.data.data),

  create: (data: CreateStructureRequest) =>
    api.post<ApiResponse<Structure>>('/api/structures', data).then((r) => r.data.data),

  update: (id: number, data: UpdateStructureRequest) =>
    api.put<ApiResponse<Structure>>(`/api/structures/${id}`, data).then((r) => r.data.data),

  delete: (id: number) =>
    api.delete(`/api/structures/${id}`),
}
